import React from 'react'
import Modal from '../modals/wrapper'
import Spinner from '../common/spinner-container'

const LoginBusyModal = () => {
    return (
        <Modal
            size='sm'
            backdrop='static'
        >
            <div style={{ padding: '20px'}}>
                <Spinner label='Checking login...' />
            </div>
        </Modal>
    )
}

export default LoginBusyModal